// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"beg_a bhb_bk bhb_bl bhb_bo","SwipeLeftToClose--animating":"beg_b"};